import { render, staticRenderFns } from "./culture-form.vue?vue&type=template&id=544209b1&scoped=true"
import script from "./culture-form.vue?vue&type=script&lang=js"
export * from "./culture-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544209b1",
  null
  
)

export default component.exports